export const translations = {
  appTitle: 'Autismus',
  appDescription: 'Comunicação Aumentativa e Alternativa',
  categories: {
    actions: 'Ações',
    animals: 'Animais',
    body: 'Corpo Humano',
    clothes: 'Roupa',
    colors: 'Cores',
    emotions: 'Sentimentos',
    food: 'Comidas e Bebidas',
    social: 'Social',
    numbers: 'Números',
    objects: 'Objetos',
    places: 'Lugares',
    weather: 'Tempo',
    leisure: 'Lazer',
    opinion: 'Opinião',
    questions: 'Perguntas'
  },
  cards: {},
  theme: {
    light: 'Modo Claro',
    dark: 'Modo Escuro',
    toggleTheme: 'Alternar tema',
  },
};